import { render, staticRenderFns } from "./ReCurator.vue?vue&type=template&id=e4039746&scoped=true"
import script from "./ReCurator.vue?vue&type=script&lang=js"
export * from "./ReCurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4039746",
  null
  
)

export default component.exports